module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/button-inset-border/button-inset-border.component.scss
// module id = ./src/app/features/buttons/button-inset-border/button-inset-border.component.scss
// module chunks = main